/* Product page for agent-made T-shirts (sections/macmerise-agent-tee.liquid). The garment is drawn live
   in the selected colour by the customiser's renderers — ClassicBrowser for the hero and accent sides,
   TeePhotoBrowser for the regular-tee photo views — with the agent's artwork at the default placement
   (centred in the print area, scale 1). Placement is fixed: the tee is bought as it is. Colour and size
   pick the variant the theme's product form adds to the cart. */
(function () {
  'use strict'
  var PROXY = 'https://aiapi.macmerise.com/api/design-image?file='
  // Canvases read artwork through the API proxy: the CDN copy can be cached without CORS headers.
  // Agent art keeps its agent/ prefix in the proxy's file name; customer designs are named bare.
  var PROXIED = [
    ['https://cdn.macmerise.com/customiser/agent/', 'agent/'],
    ['https://cdn.macmerise.com/customiser/designs/', ''],
    ['https://storage.googleapis.com/ai-customizer-v2/designs/', '']
  ]
  // A 1×1 transparent GIF: the garment shows plain until (or without) artwork.
  var BLANK_ART = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  // Sides each layout prints, hero first.
  var LAYOUTS = { 'front-hero': ['front'], 'back-hero': ['back'], 'front-hero-back-accent': ['front', 'back'], 'front-accent-back-hero': ['back', 'front'] }

  function viaProxy(url) {
    for (var i = 0; i < PROXIED.length; i++) {
      if (url.indexOf(PROXIED[i][0]) === 0) return PROXY + encodeURIComponent(PROXIED[i][1] + url.slice(PROXIED[i][0].length))
    }
    return url
  }

  // Unpublished (preview) themes only: ?test_front= / ?test_back= (customiser CDN URLs), ?test_layout=
  // and ?test_garment= stand in for the metafields, to try the page on a product that has none yet.
  function testOverrides(config) {
    var theme = window.Shopify && window.Shopify.theme
    if (!theme || theme.role === 'main') return
    var q = new URLSearchParams(location.search)
    ;['front', 'back'].forEach(function (side) {
      var url = q.get('test_' + side)
      if (url && url.indexOf('https://cdn.macmerise.com/customiser/') === 0) config[side] = url
    })
    if (LAYOUTS[q.get('test_layout')]) config.layout = q.get('test_layout')
    if (q.get('test_garment') === 'regular' || q.get('test_garment') === 'oversized') config.garment = q.get('test_garment')
  }

  function init(root) {
    if (root.dataset.ready) return
    root.dataset.ready = 'true'
    var section = root.closest('.shopify-section') || document
    var product = JSON.parse(section.querySelector('script[data-agent-tee-product]').textContent)
    var config = { front: root.dataset.frontArt || '', back: root.dataset.backArt || '', layout: root.dataset.layout, garment: root.dataset.garment }
    testOverrides(config)

    var order = LAYOUTS[config.layout] || LAYOUTS['front-hero']
    var sides = order.filter(function (side) { return config[side] })
    if (!sides.length) sides = [order[0]]
    var materials = window.ClassicMaterial.variants, palette = materials[config.garment + '-' + sides[0]].palette
    var title = root.querySelector('.mm-agent-tee__title').textContent.trim()

    var variants = product.variants, ci = product.colourIndex, si = product.sizeIndex
    var current = variants.filter(function (v) { return v.id === product.selected })[0] || variants[0]
    function colourOf(v) { return ci === null ? null : v.options[ci] }
    function sizeOf(v) { return si === null ? null : v.options[si] }
    function colour() { return colourOf(current) || 'White' }
    function find(c, s) { return variants.filter(function (v) { return (ci === null || v.options[ci] === c) && (si === null || v.options[si] === s) })[0] }

    // Hero and accent sides: one garment each, the hero shown first.
    var stages = {}
    sides.forEach(function (side) {
      var stage = root.querySelector('[data-stage="' + side + '"]'), base = stage.querySelector('[data-garment-base]'), art = stage.querySelector('[data-garment-art]')
      base.src = materials[config.garment + '-' + side].source
      art.src = config[side] ? viaProxy(config[side]) : BLANK_ART
      stage.hidden = side !== sides[0]
      stages[side] = window.ClassicBrowser.mount(base, art, stage.querySelector('[data-garment-shadow]'), stage.querySelector('[data-garment-light]'), function () {
        return { productType: config.garment, view: side, colour: colour() }
      })
    })

    var toggle = root.querySelector('[data-sides]')
    if (sides.length > 1) {
      var sideButtons = Array.prototype.slice.call(toggle.querySelectorAll('[data-side-button]'))
      var show = function (side) {
        sides.forEach(function (s) { root.querySelector('[data-stage="' + s + '"]').hidden = s !== side })
        sideButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.sideButton === side)) })
      }
      sideButtons.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.sideButton) }) })
      toggle.hidden = false
      show(sides[0])
    }

    // Regular tee: the photo views of the printed sides, hero side first, the fabric close-up last.
    var photos = null, photoBox = root.querySelector('[data-photos]')
    if (config.garment === 'regular' && window.TeePhotoBrowser && window.TeePhotoMaterial) {
      var rank = function (view) { return !view.side ? 2 : view.side === sides[0] ? 0 : 1 }
      var views = window.TeePhotoMaterial.views.filter(function (view) { return !view.side || (sides.indexOf(view.side) !== -1 && config[view.side]) })
      views.sort(function (a, b) { return rank(a) - rank(b) })
      photoBox.innerHTML = views.map(function (view) {
        return '<div class="mm-agent-tee__photo"><canvas data-view="' + view.id + '" role="img"></canvas></div>'
      }).join('')
      photoBox.hidden = false
      photos = window.TeePhotoBrowser.mount(photoBox, function () {
        return {
          colour: colour(),
          front: sides.indexOf('front') !== -1 && config.front ? { url: viaProxy(config.front) } : null,
          back: sides.indexOf('back') !== -1 && config.back ? { url: viaProxy(config.back) } : null
        }
      })
    }

    function label() {
      sides.forEach(function (side) { stages[side].canvas.setAttribute('aria-label', title + ', ' + side + ', ' + colour()) })
      if (photos) Array.prototype.forEach.call(photoBox.querySelectorAll('canvas[data-view]'), function (c) {
        var view = window.TeePhotoMaterial.views.filter(function (v) { return v.id === c.dataset.view })[0]
        c.setAttribute('aria-label', title + ', ' + view.name + ', ' + colour())
      })
    }

    // Variant picking: swatches take the palette colour; combinations that cannot be bought are disabled.
    var form = root.querySelector('form.mm-agent-tee__form'), idInput = form.querySelector('[data-variant-id]'), button = form.querySelector('button[type="submit"]')
    form.querySelector('[name="properties[_Layout]"]').value = config.layout
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-colour]')), sizes = Array.prototype.slice.call(root.querySelectorAll('[data-size]'))
    var price = root.querySelector('[data-price]'), compare = root.querySelector('[data-compare-price]'), colourLabel = root.querySelector('[data-colour-label]')

    function render() {
      idInput.value = current.id
      price.textContent = current.price
      compare.textContent = current.compare || ''
      compare.hidden = !current.compare
      button.disabled = !current.available
      button.classList.toggle('button--subdued', !current.available)
      // The theme's custom-button wraps the label in a div beside its loader.
      var text = button.firstElementChild && button.firstElementChild.tagName === 'DIV' ? button.firstElementChild : button
      text.textContent = current.available ? product.addLabel : product.soldOutLabel
      if (colourLabel) colourLabel.textContent = colourOf(current)
      swatches.forEach(function (b) {
        var value = b.dataset.colour
        b.setAttribute('aria-pressed', String(value === colourOf(current)))
        b.disabled = !variants.some(function (v) { return v.options[ci] === value && v.available })
      })
      sizes.forEach(function (b) {
        var v = find(colourOf(current), b.dataset.size)
        b.setAttribute('aria-pressed', String(b.dataset.size === sizeOf(current)))
        b.disabled = !v || !v.available
      })
      label()
    }

    function select(v) {
      var recolour = colourOf(v) !== colourOf(current)
      current = v
      render()
      var url = new URL(location.href)
      url.searchParams.set('variant', v.id)
      history.replaceState(history.state, '', url)
      if (recolour) {
        sides.forEach(function (side) { stages[side].update() })
        if (photos) photos.update()
      }
    }

    swatches.forEach(function (b) {
      var match = window.ClassicRenderer.find(palette, b.dataset.colour)
      if (match) b.style.setProperty('--swatch', match.hex)
      b.addEventListener('click', function () {
        var value = b.dataset.colour, v = find(value, sizeOf(current))
        if (!v || !v.available) v = variants.filter(function (x) { return x.options[ci] === value && x.available })[0] || v
        if (v) select(v)
      })
    })
    sizes.forEach(function (b) {
      b.addEventListener('click', function () { var v = find(colourOf(current), b.dataset.size); if (v) select(v) })
    })
    render()
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-agent-tee]'), init)
  document.addEventListener('shopify:section:load', function (e) { Array.prototype.forEach.call(e.target.querySelectorAll('[data-agent-tee]'), init) })
})()
